import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M4 18h7M4 6h16zm0 6h16z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".95",
      d: "M16.955 23c1.723 0 2.978-.954 2.974-2.27.004-.973-.625-1.673-1.755-1.829v-.06c.874-.183 1.46-.81 1.456-1.685C19.634 15.97 18.588 15 16.978 15c-1.566 0-2.777.901-2.809 2.205h1.405c.023-.654.653-1.06 1.397-1.06.751 0 1.25.44 1.247 1.095.004.68-.579 1.133-1.413 1.133h-.712v1.087h.712c1.02 0 1.625.494 1.621 1.198.004.688-.613 1.16-1.475 1.16-.81 0-1.436-.407-1.472-1.042H14C14.04 22.09 15.255 23 16.955 23M24.09 22.894c2.454 0 3.91-1.468 3.91-3.902 0-2.425-1.456-3.886-3.856-3.886H21.36v7.788zm-1.272-1.221v-5.346h1.243c1.637 0 2.491.882 2.491 2.665 0 1.791-.854 2.681-2.534 2.681z"
    }, null, -1)
  ])))
}
export default { render: render }